import type { ErrorResponse } from '@/types/apiTypes';

export const getFieldError = <T extends Record<string, unknown>>(
  error: ErrorResponse<T> | undefined,
  fieldKey?: string
): string | number | null => {
  if (!fieldKey || !error || typeof error.errors !== 'object') return null;

  const keys = fieldKey.split('.');
  let currentValue: unknown = error.errors;

  for (const key of keys) {
    if (typeof currentValue !== 'object' || currentValue === null || !(key in currentValue)) {
      return null;
    }

    currentValue = (currentValue as Record<string, unknown>)[key];
  }

  if (typeof currentValue === 'string' || typeof currentValue === 'number') {
    return currentValue;
  }

  if (Array.isArray(currentValue) && currentValue.every((v) => typeof v === 'string' || typeof v === 'number')) {
    return currentValue.join('. ');
  }

  return null;
};